import { fromJS } from 'immutable';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'connected-react-router/immutable';
import { createStore, applyMiddleware, compose } from 'redux';

import { rootReducer, rootSaga } from './reducers';
import sagaContext from './reducers/sagaContext';

const sagaMiddleware = createSagaMiddleware({ context: sagaContext });

export default function configureStore(initialState = {}, history) {
  // If Redux DevTools Extension is installed use it, otherwise use Redux compose
  const composeEnhancers =
    process.env.NODE_ENV !== 'production' &&
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ // eslint-disable-line no-underscore-dangle
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ shouldHotReload: false }) // eslint-disable-line no-underscore-dangle
      : compose;

  const store = createStore(
    rootReducer(history),
    fromJS(initialState),
    composeEnhancers(applyMiddleware(routerMiddleware(history), sagaMiddleware)),
  );

  let sagaManager = sagaMiddleware.run(rootSaga);

  /* istanbul ignore next */
  if (module.hot) {
    module.hot.accept('./reducers', () => {
      // eslint-disable-next-line global-require
      store.replaceReducer(rootReducer());

      sagaManager.cancel();
      sagaManager.done.then(() => (sagaManager = sagaMiddleware.run(rootSaga)));
    });
  }

  return store;
}
